import {InjectionKey} from "vue";

export const LightboxInjection = Symbol() as InjectionKey<(src?: string) => void>